import { api } from '../common.api';

export const developerApi = api.injectEndpoints({
  endpoints: (build) => ({
    verifyDeveloper: build.mutation<{ valid: boolean }, { password: string }>({
      query: (body) => ({
        url: '/developer/verify',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useVerifyDeveloperMutation } = developerApi;
